/* ============================================================
   Firdous Fragrance — Luxury Enhancements (scroll reveal engine)
   Adds graceful, staggered reveal animations as the visitor
   scrolls. Pairs with firdous-luxury.css.
   ============================================================ */
(function () {
  'use strict';

  var docEl = document.documentElement;

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    return;
  }

  docEl.classList.add('fd-ready');

  var SECTION_SELECTOR = [
    '.banner__box',
    '.rich-text__wrapper',
    '.section-header',
    '.collection-hero__inner',
    '.multicolumn-card',
    '.collage__item',
    '.email-signup',
    '.newsletter',
    '.contact',
    '.testimonial',
    '.image-with-text__content',
    '.image-with-text__media'
  ].join(',');

  var CARD_SELECTOR = '.card-wrapper, .grid__item .card';

  function markReveal(el, variant) {
    if (!el || el.classList.contains('fd-reveal')) return;
    el.classList.add('fd-reveal');
    if (variant) el.classList.add(variant);
  }

  var sectionEls = document.querySelectorAll(SECTION_SELECTOR);
  for (var i = 0; i < sectionEls.length; i++) {
    var el = sectionEls[i];
    var variant = '';
    if (el.classList.contains('image-with-text__media')) {
      variant = 'fd-reveal--left';
    } else if (el.classList.contains('image-with-text__content')) {
      variant = 'fd-reveal--right';
    } else if (el.classList.contains('collage__item')) {
      variant = 'fd-reveal--zoom';
    }
    markReveal(el, variant);
  }

  var grids = document.querySelectorAll(
    '.product-grid, .grid--peek, .collection .grid, .complementary-products .grid, ul.grid'
  );
  for (var g = 0; g < grids.length; g++) {
    var cards = grids[g].querySelectorAll(CARD_SELECTOR);
    for (var c = 0; c < cards.length; c++) {
      markReveal(cards[c]);
      var delay = Math.min(c * 0.08, 0.64);
      cards[c].style.setProperty('--fd-delay', delay + 's');
    }
  }

  var looseCards = document.querySelectorAll(CARD_SELECTOR);
  for (var l = 0; l < looseCards.length; l++) {
    markReveal(looseCards[l]);
  }

  var revealEls = document.querySelectorAll('.fd-reveal');

  if (!('IntersectionObserver' in window)) {
    for (var f = 0; f < revealEls.length; f++) {
      revealEls[f].classList.add('fd-in');
    }
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fd-in');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    }
  );

  for (var o = 0; o < revealEls.length; o++) {
    observer.observe(revealEls[o]);
  }

  window.addEventListener('load', function () {
    window.setTimeout(function () {
      var stillHidden = document.querySelectorAll('.fd-reveal:not(.fd-in)');
      for (var s = 0; s < stillHidden.length; s++) {
        var rect = stillHidden[s].getBoundingClientRect();
        if (rect.top < window.innerHeight) {
          stillHidden[s].classList.add('fd-in');
        }
      }
    }, 200);
  });
})();
